/* global ScrollTrigger */
const {KitModule, registerModule} = window;

class CareersList extends KitModule {
  constructor($element) {
    super($element);
    this.timer = null;

    if (this.$filters) this.$filters.addEventListener('change', this);
    if (this.$search) this.$search.addEventListener('input', this);
  }

  debounce(func, delay) {
    // Clear the previous timer if a new call happens within the delay time
    if (this.timer) clearTimeout(this.timer);

    // Set a new timer that calls the function after the delay
    this.timer = setTimeout(() => {
      func.apply(this);
    }, delay);
  }

  onchange() {
    this.updateResults();
    this.resetScroll();
    ScrollTrigger.refresh();
  }

  oninput() {
    this.debounce(() => {
      this.updateResults();
      this.resetScroll();
      ScrollTrigger.refresh();
    }, 300);
  }

  updateResults() {
    const departmentValue = this.$departmentsSelect.value;
    const locationValue = this.$locationsSelect.value;
    const searchValue = this.$search.value.toLowerCase();
    let visibleJobCount = 0;

    this.$departmentGroups.forEach(($group) => {
      // show or hide department
      const department = $group.getAttribute('data-department-group');
      if (departmentValue === 'all') {
        $group.hidden = false;
      } else {
        const isGroupHidden = department !== departmentValue;
        $group.hidden = isGroupHidden;
        if (isGroupHidden) return;
      }

      // show or hide job
      const $jobs = $group.querySelectorAll('[data-js-children="$jobs"]');
      let visibleGroupJobCount = 0;
      let locationNames = [];
      $jobs.forEach(($job) => {
        const location = $job.getAttribute('data-location');
        let isHidden;
        if (locationValue === 'all') {
          isHidden = false;
        } else {
          locationNames = location.split(';');
          isHidden = true;

          for (const locationName of locationNames) {
            if (locationName === locationValue) {
              isHidden = false;
              break;
            }
          }
        }

        // Match results to search input
        if (searchValue.length && !isHidden) {
          if (
            !$job.getAttribute('data-department').toLowerCase().includes(searchValue) &&
            !$job.getAttribute('data-location').toLowerCase().includes(searchValue) &&
            !$job.getAttribute('data-title').toLowerCase().includes(searchValue)
          ) {
            isHidden = true;
          }
        }

        $job.hidden = isHidden;
        visibleGroupJobCount += isHidden ? 0 : 1;
      });
      // hide group with no matching jobs
      if (!visibleGroupJobCount) $group.hidden = true;
      visibleJobCount += visibleGroupJobCount;
    });

    // show no results if no visibleJob
    this.$noResultsMessage.hidden = visibleJobCount ? true : false;
  }

  resetScroll() {
    // grab fresh heights
    const htmlStyle = getComputedStyle(document.documentElement);
    let navHeight = htmlStyle.getPropertyValue('--nav-height');

    // if navHeight is a rem value, we have some calculating to do
    if (navHeight.endsWith('rem')) {
      navHeight = parseInt(navHeight) * parseInt(htmlStyle.fontSize);
    }

    // Reset scroll position to top of careers section
    const careersTop = (this.$element.getBoundingClientRect().top + document.documentElement.scrollTop) - parseInt(navHeight);
    setTimeout(() => {
      window.scrollTo({
        top: careersTop,
        left: 0,
      });
    }, 150);
  }

  unmount() {
    if (this.$filters) this.$filters.removeEventListener('change', this);
  }
}

registerModule('CareersList', CareersList);
